import { get } from './api';

let cache = null;
let inflight = null;

export function emptySectionLocks() {
  return {
    questions: false,
    notes: false,
    mocks: false,
  };
}

/** Label for locked-section subscribe popup, e.g. "Subscribe to Mocks". */
export function subscribeSectionMessage(sectionKeyOrLabel) {
  const name = sectionDisplayName(sectionKeyOrLabel);
  return `Subscribe to ${name}`;
}

/** Label for subscribed-section unsubscribe popup, e.g. "Unsubscribe from Mocks". */
export function unsubscribeSectionMessage(sectionKeyOrLabel) {
  const name = sectionDisplayName(sectionKeyOrLabel);
  return `Unsubscribe from ${name}`;
}

function sectionDisplayName(sectionKeyOrLabel) {
  const raw = String(sectionKeyOrLabel || '').trim().toLowerCase();
  if (raw === 'questions' || raw === 'question') return 'Questions';
  if (raw === 'notes' || raw === 'note') return 'Notes';
  if (raw === 'mocks' || raw === 'mock') return 'Mocks';
  if (raw) {
    const name = String(sectionKeyOrLabel).trim();
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  return 'this section';
}

export function clearSectionLocksCache() {
  cache = null;
  inflight = null;
}

/** Update in-memory locks so all screens see unsubscribe/lock immediately. */
export function setSectionLocksCache(locks) {
  cache = {
    questions: !!(locks && locks.questions),
    notes: !!(locks && locks.notes),
    mocks: !!(locks && locks.mocks),
  };
  return cache;
}

/**
 * @returns {Promise<{questions: boolean, notes: boolean, mocks: boolean}>}
 */
export function fetchSectionLocks(force = false) {
  if (!force && cache) {
    return Promise.resolve(cache);
  }
  if (!force && inflight) {
    return inflight;
  }

  inflight = get('/section-locks')
    .then((res) => {
      const locks = (res.data && res.data.locks) || {};
      cache = {
        questions: !!locks.questions,
        notes: !!locks.notes,
        mocks: !!locks.mocks,
      };
      return cache;
    })
    .catch(() => {
      cache = emptySectionLocks();
      return cache;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

export function sectionForPath(path) {
  const p = String(path || '').toLowerCase();
  if (
    p.includes('/mlalistselection') ||
    p.includes('/questionspage') ||
    p.includes('/questionbirdseyeview')
  ) {
    return 'questions';
  }
  if (p.includes('/noteslistselection') || p.includes('/notespage')) {
    return 'notes';
  }
  if (
    p.includes('/mocksection') ||
    p.includes('/mockselection') ||
    p.includes('/mocksquestion') ||
    p.includes('/mockbirdseye') ||
    p.includes('/mockscore') ||
    p.includes('/reviewmockbirdseye') ||
    p.includes('/reviewscroll')
  ) {
    return 'mocks';
  }
  return null;
}
